import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import useWindowSize from 'utils/hooks/useWindowSize';
import styles from 'sections/DigitalTools/LogisticsExplorer/components/SectionAbout/SectionAbout.module.scss';

const cn = classNames.bind(styles);

const SectionAbout = (): ReactElement => {
  const { width: screenWidth } = useWindowSize();

  return (
    <section className={cn('about')}>
      <div className={cn('container')}>

        <div className={cn('about__section')}>
          <div className={cn('about__image-box')}>
            <picture>
              <source
                srcSet="
                /images/pages/DigitalTools/LogisticsExplorer/tariffs-mobile.webp 1x,
                /images/pages/DigitalTools/LogisticsExplorer/tariffs-mobile@2x.webp 2x
              "
                sizes="100vw"
                media="(max-width: 575px)"
              />
              <source
                srcSet="
                /images/pages/DigitalTools/LogisticsExplorer/tariffs-tablet.webp 1x,
                /images/pages/DigitalTools/LogisticsExplorer/tariffs-tablet@2x.webp 2x
              "
                sizes="100vw"
                media="(max-width: 1024px)"
              />
              <source
                srcSet="
                /images/pages/DigitalTools/LogisticsExplorer/tariffs-desktop.webp 1x,
                /images/pages/DigitalTools/LogisticsExplorer/tariffs-desktop@2x.webp 2x
              "
                sizes="100vw"
              />
              <img
                className={cn('about__image')}
                src="/images/pages/DigitalTools/LogisticsExplorer/tariffs-desktop.webp"
                alt="ship schedules"
              />
            </picture>
          </div>
          <div className={cn('about__content')}>
            <h2 className={cn('about__heading')}>
              {screenWidth > 1025 &&
                <>
                  <span>Logistics Explorer:</span>
                  <span>A Smart Tool to Sell Freight</span>
                  <span>and Earn More</span>
                </>
              }
              {screenWidth <= 1025 &&
                <>
                  <span>Logistics Explorer:</span>
                  <span>A Smart Tool to Sell Freight and Earn More</span>
                </>
              }
            </h2>
            <p className={cn('about__paragraph')}>
              Whether you're a shipping specialist or a trading team, you can
              significantly streamline supply chain operations with the Logistics Explorer.
            </p>
            <p className={cn('about__paragraph')}>
              Carriers can submit shipping rates, by sea, land, or air, and start
              securing bookings 24/7, turning their site into a sales-ready, self-operating
              system that works in the background around the clock.
            </p>
            <p className={cn('about__paragraph')}>
              Trading companies can capitalise on the cargo freight calculator by connecting
              Logistics Explorer to their systems, gaining access to live rates on
              SeaRates.com and simplifying cost calculations across all Incoterms.
            </p>
          </div>
        </div>

      </div>
    </section>
  );
};

export default SectionAbout;